import { styled } from '@mui/system';
import { AgColor } from '../../stories/Styles/AgColor';

export const Main = styled('main')`
  height: calc(100% - 20px);
  padding: 10px 2em;
`;

export const Container = styled('section')`
  margin-top: 3.4em;

  .MuiDataGrid-columnHeader:nth-of-type(2),
  .MuiDataGrid-cell:nth-of-type(2) {
    border-right: 0 !important;
  }

  .MuiDataGrid-columnHeader:nth-of-type(1),
  .MuiDataGrid-cell:nth-of-type(1) {
    border-right: .25px solid ${AgColor.grey4};
  }
`;